export const en = {
  common: {
    loading: 'Loading...',
    email: 'Email',
    emailRequired: 'Please enter your email!',
    emailValid: 'Please enter a valid email address!',
    password: 'Password',
    passwordRequired: 'Please enter your password!',
    passwordMin: 'Password must be at least 6 characters!',
    confirmPassword: 'Confirm Password',
    confirmPasswordRequired: 'Please confirm your password!',
    confirmPasswordNotMatch: 'The two passwords do not match!',
    back: 'Back',
    and: 'and',
    agreementUser: 'User Agreement',
    agreementPrivacy: 'Privacy Policy',
    submit: 'Submit',
    contact: 'Contact Info',
    feedback: 'Feedback',
    success: 'Success',
    fail: 'Failed',
    nickname: 'Nickname',
    avatar: 'Avatar',
    language: 'Language',
    logout: 'Logout',
    privacy: 'Privacy Policy',
    manual: 'Manual',
    userAgreement: 'User Agreement',
    ok: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    warning: 'Warning',
    info: 'Info',
    yes: 'Yes',
    no: 'No',
    copy: 'Copy',
    export: 'Export',
    save: 'Save',
    close: 'Close',
    empty: 'No Data',
    input: 'Please enter',
    name: 'Name',
    newName: 'New Name',
    unchanged: 'No change',
    updateSuccess: 'Update successful',
    updateFail: 'Update failed, please try again later',
    deleteSuccess: 'Delete successful',
    deleteFail: 'Delete failed, please try again later',
    confirmDelete: 'Confirm Delete',
    confirm: 'Confirm',
    know: 'Got it',
    file: 'File',
    fileName: 'File Name',
    fileType: 'File Type',
    fileList: 'File Records',
    operation: 'Operation',
    rename: 'Rename',
    sync: 'Sync',
    detail: 'Detail',
    download: 'Download',
    retry: 'Retry',
    start: 'Start',
    stop: 'Stop',
    continue: 'Continue',
    finish: 'Finish',
    tip: 'Tip',
    more: 'More',
    search: 'Search',
  },
  aside: {
    allFile: 'All Files',
    allTypes: 'All Types',
    setting: 'Preference Settings',
    helpFeed: 'Help & Feedback',
    code: 'QRCode',
    scanCode: 'Scan QR Code to Download APP',
  },
  login: {
    title: 'Login',
    loginBtn: 'Login',
    forgot: 'Forgot password',
    noAccount: 'No account yet?',
    register: 'Register now',
    agreementPrefix: 'By continuing, you agree to the',
    loginSuccess: 'Login successful!',
    loginFail: 'Login failed, please check your username and password!',
  },
  profile: {
    avatar: 'Avatar',
    nickname: 'Nickname',
    language: 'Language',
    logout: 'Logout',
    privacy: 'Privacy Policy',
    manual: 'Manual',
    userAgreement: 'User Agreement',
  },
  register: {
    title: 'Register Account',
    agree: 'I have read and agree to the',
    submit: 'Submit',
    agreeTip: 'Please agree to the User Agreement and Privacy Policy!',
    success: 'Registration successful! Please login',
    fail: 'Registration failed, please try again later!',
  },
  resetPassword: {
    title: 'Reset Password',
    code: 'Enter the verification code',
    codeRequired: 'Please enter the verification code!',
    getCode: 'Get Code',
    codeSent: 'Verification code sent, please check your email',
    codeFail: 'Failed to send verification code, please try again later!',
    newPassword: 'Please enter your new password!',
    submit: 'Confirm',
    emailTip: 'Please enter your email first!',
    success: 'Password reset successful, please login again!',
    fail: 'Password reset failed, please try again later!',
  },
  feedback: {
    title: 'Feedback',
    contentLabel: 'Your question or suggestion',
    contentPlaceholder: 'Please describe your issue or suggestion in detail...',
    contentRequired: 'Please enter details',
    typeLabel: 'Type',
    typeLabelHolder: 'Please select a feedback type',
    typeRequired: 'Please enter feedback title',
    typeBug: 'Bug',
    typeFeature: 'Feature Request',
    typeUI: 'UI Optimization',
    typePerformance: 'Performance Issue',
    typeOther: 'Other',
    contactLabel: 'Contact Info',
    contactRequired: 'Please enter your contact info',
    contactPlaceholder: 'Please enter your contact info',
    submit: 'Submit Feedback',
    success: 'Thank you for your feedback!',
    fail: 'Submission failed, please try again later',
  },
  file: {
    welcome: 'Welcome to AILITH WEB!',
    listTitle: 'File Records',
    deleteTitle: 'Delete File',
    deleteContent: 'This file will be permanently deleted and cannot be recovered. Are you sure you want to delete it?',
    deleteOk: 'Delete',
    deleteCancel: 'Cancel',
    deleteSuccess: 'File deleted successfully',
    deleteFail: 'Failed to delete file, please try again later',
    transcription: 'Transcription',
    welcomeTranscription: 'Welcome to experience AI transcription!',
    generate: 'Generate',
    transcribing: 'Transcribing in progress...',
    transcribingTip: 'This may take a few minutes. The result will be displayed automatically when finished. You can leave this page or wait here.',
    transcribeFail: 'Transcription failed!',
    transcribeFailTip: 'Failed to generate transcription. Please try again.',
    regenerate: 'Regenerate',
    regenerateTrans: 'Are you sure you want to retry generating the transcription content of the current audio?',
    regenerateSummary: 'Are you sure to retry generating the summary content of the current audio?',
    summaryGenerating: 'Summary is being generated...',
    summaryGeneratingTip: 'Transcription is done. Summary will be ready in a few minutes. You can wait or view the transcription.',
    viewTranscription: 'View Transcription',
    summaryFail: 'Summary failed',
    summaryFailTip: 'Failed to generate summary. Please try again.',
    selectTemplate: 'Select Template',
    selectTemplateLanguage: 'Recording Language',
    meetingSummary: 'Meeting Summary',
    topic: 'Topic',
    todo: 'To-do',
    interview: 'Interview',
    qa: 'Q&A',
    opinion: 'Opinion',
    speech: 'Speech',
    summary: 'Summary',
    question: 'Question',
    startTranscribing: 'Starting transcription...',
    transcribeStarted: 'Transcription started, please check back later.',
    transcribeFailRetry: 'Transcription failed, please try again later.',
    transcribe: 'transcribe',
    retranscribe: 'Retranscribe',
    resummarize: 'Resummarize',
    rename: 'Rename',
    renamePlaceholder: 'Please enter new name',
    renameOk: 'Got it',
    renameCancel: 'Cancel',
    renameSuccess: 'File name updated successfully',
    renameFail: 'Failed to update file name, please try again later',
    renameUnchanged: 'No changes were made to the file name',
    renameRequired: 'Please enter a new file name',
    delete: 'Delete',
    copyTranscription: 'Copy Transcribed Text',
    copySummary: 'Copy Summary Text',
    exportTranscription: 'Export Transcription',
    exportSummary: 'Export Summary',
    exportMindmap: 'Export Mind Map',
    exportMp3: 'Export Audio',
    copy: 'Copy',
    export: 'Export',
    empty: 'No data available',
    exportSuccess: 'Export successful',
    exportFail: 'Export failed',
    syncTip: 'Learn how to sync data',
    syncTipDesc: 'To view your data here, open the latest version of the AILITH APP and enable AILITH PRIVATE CLOUD.',
    copySuccess: 'Content copied to clipboard',
    dateTime: 'Date & Time',
    location: 'Location',
    attendees: 'Attendees',
    meetingRecord: 'Meeting Record',
    nextStep: 'Next Step',
    interviewer: 'Interviewer',
    conclusion: 'Conclusion',
    speaker: 'Speaker',
    abstract: 'Abstract',
    keyPoints: 'Key Points',
    questions: 'Questions',
    assignments: 'Assignments',
    showList: 'Show List',
    hideList: 'Hide List',
    hideTranscript: 'Hide Transcription',
    showTranscript: 'Show Transcription',
    summaryz: 'Summary',
    mind: 'Mind',
    zd: 'Autopilot',
    zdTag1: 'Adaptive Structure',
    zx: 'Consultation',
    zxTag1: 'Achievements',
    zxTag2: 'Decisions',
    hb: 'Report',
    hbTag1: 'Progress',
    hbTag2: 'Problems',
    tl: 'Discussion',
    tlTag1: 'Conclusions',
    tlTag2: 'Key points',
    bj: 'Class Notes',
    bjTag1: 'Knowledge points',
    bjTag2: 'Explanation',
    px: 'Training',
    pxTag1: 'Key Points',
    pxTag2: 'Notes',
    xq: 'Needs Assessment',
    xqTag1: 'Pain Points',
    xqTag2: 'Expectations',

  },
  vip: {
    lock: "Unlock Starter Membership",
    lockDesc: "Bind an AILITH device to activate Starter membership benefits",
    lockNowBtnText: "Unlock Now",
    starVipName: "Starter Membership",
    proVipName: "Pro Membership",
    unlimitedVipName: "Unlimited Membership",
    transTimeName: "Transcription Time Pack",
    timeReset: "Reset",
    timeEnd: "Expires",
    lockTitle: "Unlock Starter Membership",
    lockSubTitle: "Please open the AILITH app and bind your AILITH device to activate your Starter membership benefits",
    lockRights1: "400 minutes of transcription time per month",
    lockRights2: "Multiple scene templates for smart summaries",
    lockRights3: "Speaker separation for multi-person conversations",
    lockRights4: "AI voice enhancement for improved audio playback",
    lockRights5: "Supports multiple export formats including TXT and Markdown"
  }
}; 

